import { render, staticRenderFns } from "./LiaHeaderButton.vue?vue&type=template&id=2a67bfb8&scoped=true&"
import script from "./LiaHeaderButton.vue?vue&type=script&lang=js&"
export * from "./LiaHeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./LiaHeaderButton.vue?vue&type=style&index=0&id=2a67bfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67bfb8",
  null
  
)

export default component.exports